import api from './api';

// ─── Finish Groups (Level 1) ───
export const getFinishGroups = async () => {
  const { data } = await api.get('/finishes/groups');
  return data;
};
export const createFinishGroup = async (name) => {
  const { data } = await api.post('/finishes/groups', { name });
  return data;
};
export const updateFinishGroup = async (id, params) => {
  const { data } = await api.put(`/finishes/groups/${id}`, params);
  return data;
};
export const deleteFinishGroup = async (id) => {
  const { data } = await api.delete(`/finishes/groups/${id}`);
  return data;
};

// ─── Finish Types (Level 2) ───
export const getFinishTypes = async (groupId) => {
  const params = groupId ? { group_id: groupId } : {};
  const { data } = await api.get('/finishes/types', { params });
  return data;
};
export const getFinishType = async (id) => {
  const { data } = await api.get(`/finishes/types/${id}`);
  return data;
};
export const createFinishType = async (params) => {
  const { data } = await api.post('/finishes/types', params);
  return data;
};
export const updateFinishType = async (id, params) => {
  const { data } = await api.put(`/finishes/types/${id}`, params);
  return data;
};
export const deleteFinishType = async (id) => {
  const { data } = await api.delete(`/finishes/types/${id}`);
  return data;
};
export const updateTypeManufacturers = async (id, manufacturerIds) => {
  const { data } = await api.put(`/finishes/types/${id}/manufacturers`, { manufacturer_ids: manufacturerIds });
  return data;
};
export const updateTypeFeatures = async (id, featureIds) => {
  const { data } = await api.put(`/finishes/types/${id}/features`, { feature_ids: featureIds });
  return data;
};
export const updateTypeMappings = async (id, mappings) => {
  const { data } = await api.put(`/finishes/types/${id}/mappings`, { mappings });
  return data;
};
export const updateTypeStoreStatus = async (id, storeStatuses) => {
  const { data } = await api.put(`/finishes/types/${id}/store-status`, { store_statuses: storeStatuses });
  return data;
};
export const bulkUpdateTypeStoreStatus = async (typeIds, storeId, status) => {
  const { data } = await api.put('/finishes/types/bulk-store-status', { type_ids: typeIds, store_id: storeId, status });
  return data;
};
export const bulkDeleteTypes = async (typeIds) => {
  const { data } = await api.delete('/finishes/types/bulk-delete', { data: { type_ids: typeIds } });
  return data;
};
export const bulkDeleteGroups = async (groupIds) => {
  const { data } = await api.delete('/finishes/groups/bulk-delete', { data: { group_ids: groupIds } });
  return data;
};

// ─── Shopify Linking ───
export const pushFinishType = async (id, storeId) => {
  const { data } = await api.post(`/finishes/types/${id}/push`, { store_id: storeId });
  return data;
};
export const searchShopifyForType = async (storeId, query) => {
  const { data } = await api.get('/finishes/types/search-shopify', { params: { store_id: storeId, query } });
  return data;
};
export const matchFinishType = async (id, storeId, shopifyProductId) => {
  const { data } = await api.put(`/finishes/types/${id}/match`, { store_id: storeId, shopify_product_id: shopifyProductId });
  return data;
};
export const unmatchFinishType = async (id, storeId) => {
  const { data } = await api.put(`/finishes/types/${id}/unmatch`, { store_id: storeId });
  return data;
};
export const updateFinishTypeShopifyStatus = async (id, storeId, shopifyStatus) => {
  const { data } = await api.put(`/finishes/types/${id}/shopify-status`, { store_id: storeId, shopify_status: shopifyStatus });
  return data;
};

// ─── Finish Colors (Level 3) ───
export const getFinishColors = async (typeId) => {
  const params = typeId ? { type_id: typeId } : {};
  const { data } = await api.get('/finishes/colors', { params });
  return data;
};
export const importFinishes = async (items) => {
  const { data } = await api.post('/finishes/import', { items });
  return data;
};
export const exportFinishesFull = async () => {
  const token = localStorage.getItem('token');
  return fetch('/api/finishes/export-full', { headers: { Authorization: `Bearer ${token}` } });
};
export const exportFinishesJson = async () => {
  const { data } = await api.get('/finishes/export-json');
  return data;
};
export const createFinishColor = async (params) => {
  const { data } = await api.post('/finishes/colors', params);
  return data;
};
export const updateFinishColor = async (id, params) => {
  const { data } = await api.put(`/finishes/colors/${id}`, params);
  return data;
};
export const deleteFinishColor = async (id) => {
  const { data } = await api.delete(`/finishes/colors/${id}`);
  return data;
};
